import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, vModelSelect as _vModelSelect, unref as _unref, renderList as _renderList, Fragment as _Fragment, createVNode as _createVNode, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-4378c672"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "edit-calendar-container" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "Edit Calendar", -1))
const _hoisted_3 = {
  key: 0,
  class: "error-message"
}
const _hoisted_4 = {
  key: 1,
  class: "loading"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Loading calendar data...", -1))
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = { class: "form-group" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "name" }, "Calendar Name *", -1))
const _hoisted_9 = { class: "form-group" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "description" }, "Description", -1))
const _hoisted_11 = { class: "form-row" }
const _hoisted_12 = { class: "form-group" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "type" }, "Calendar Type *", -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "" }, "Select Type", -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "school" }, "School", -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "district" }, "District", -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "student" }, "Student", -1))
const _hoisted_18 = [
  _hoisted_14,
  _hoisted_15,
  _hoisted_16,
  _hoisted_17
]
const _hoisted_19 = { class: "form-group" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "academicYear" }, "Academic Year", -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "" }, "Select Academic Year", -1))
const _hoisted_22 = ["value"]
const _hoisted_23 = {
  key: 0,
  class: "form-group"
}
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "schoolId" }, "School *", -1))
const _hoisted_25 = {
  key: 1,
  class: "form-group"
}
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "districtId" }, "District *", -1))
const _hoisted_27 = {
  key: 2,
  class: "form-group"
}
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "studentId" }, "Student *", -1))
const _hoisted_29 = { class: "form-row" }
const _hoisted_30 = { class: "form-group" }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "startDate" }, "Start Date *", -1))
const _hoisted_32 = { class: "form-group" }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "endDate" }, "End Date *", -1))
const _hoisted_34 = { class: "form-section" }
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Additional Settings", -1))
const _hoisted_36 = { class: "form-group" }
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "status" }, "Status", -1))
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "active" }, "Active", -1))
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "archived" }, "Archived", -1))
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "draft" }, "Draft", -1))
const _hoisted_41 = [
  _hoisted_38,
  _hoisted_39,
  _hoisted_40
]
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", { class: "form-help" }, "Set to \"Active\" to make this calendar visible to users", -1))
const _hoisted_43 = { class: "form-actions" }
const _hoisted_44 = ["disabled"]
const _hoisted_45 = { key: 0 }
const _hoisted_46 = { key: 1 }

import { ref, reactive, onMounted, computed } from "vue";
import { useRouter, useRoute } from "vue-router";
import axios from "axios";
import { API_URL } from "../config";
import SearchableDropdown from "../components/SearchableDropdown.vue";
import { getErrorMessage } from "../types";
import type { OrganizationRecord } from "../types";

interface DistrictSummary {
  id: number;
  name: string;
}

interface StudentSummary {
  id: number;
  name: string;
}

// Router and Route

export default /*#__PURE__*/_defineComponent({
  __name: 'EditCalendarView',
  setup(__props) {

const router = useRouter();
const route = useRoute();
const calendarId = Number(route.params.calendarId);

// State
const error = ref("");
const loading = ref(true);
const isSubmitting = ref(false);

// Data loading states
const loadingSchools = ref(false);
const loadingDistricts = ref(false);
const loadingStudents = ref(false);

// Data lists
const schools = ref<OrganizationRecord[]>([]);
const districts = ref<DistrictSummary[]>([]);
const students = ref<StudentSummary[]>([]);

// Generate academic years (current year - 2 to current year + 5)
const currentYear = new Date().getFullYear();
const academicYears = Array.from({ length: 8 }, (_, i) => currentYear - 2 + i);

// Form data
const formData = reactive({
  name: "",
  description: "",
  type: "",
  academicYear: "",
  startDate: "",
  endDate: "",
  status: "active",
  schoolId: "",
  districtId: "",
  studentId: "",
});

// Add computed properties for dropdown options
const schoolOptions = computed(() => {
  return schools.value.map((school) => ({
    value: school.id.toString(),
    label: school.name,
  }));
});

const districtOptions = computed(() => {
  return districts.value.map((district) => ({
    value: district.id.toString(),
    label: district.name,
  }));
});

const studentOptions = computed(() => {
  return students.value.map((student) => ({
    value: student.id.toString(),
    label: student.name,
  }));
});

// Format date for input fields (YYYY-MM-DD)
const formatDateForInput = (dateString: string): string => {
  if (!dateString) return "";

  const date = new Date(dateString);
  if (isNaN(date.getTime())) return "";

  return date.toISOString().split("T")[0];
};

// Fetch schools
const fetchSchools = async () => {
  loadingSchools.value = true;
  try {
    const response = await axios.get(`${API_URL}/organizations`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    });
    schools.value = response.data;
  } catch (err: unknown) {
    console.error("Error fetching schools:", err);
    error.value = "Failed to load schools. Please try again.";
  } finally {
    loadingSchools.value = false;
  }
};

// Fetch districts
const fetchDistricts = async () => {
  loadingDistricts.value = true;
  try {
    const response = await axios.get(`${API_URL}/districts`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    });
    districts.value = response.data;
  } catch (err: unknown) {
    console.error("Error fetching districts:", err);
    error.value = "Failed to load districts. Please try again.";
  } finally {
    loadingDistricts.value = false;
  }
};

// Fetch students
const fetchStudents = async () => {
  loadingStudents.value = true;
  try {
    const response = await axios.get(`${API_URL}/students`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    });
    students.value = response.data;
  } catch (err: unknown) {
    console.error("Error fetching students:", err);
    error.value = "Failed to load students. Please try again.";
  } finally {
    loadingStudents.value = false;
  }
};

// Handle type change
const handleTypeChange = () => {
  // Reset the IDs
  formData.schoolId = "";
  formData.districtId = "";
  formData.studentId = "";

  // Fetch the appropriate data based on the selected type
  if (formData.type === "school" && schools.value.length === 0) {
    fetchSchools();
  } else if (formData.type === "district" && districts.value.length === 0) {
    fetchDistricts();
  } else if (formData.type === "student" && students.value.length === 0) {
    fetchStudents();
  }
};

// Fetch calendar data
const fetchCalendar = async () => {
  loading.value = true;
  try {
    const response = await axios.get(`${API_URL}/calendar/${calendarId}`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    });

    const calendar = response.data;

    // Populate form data
    formData.name = calendar.name || "";
    formData.description = calendar.description || "";
    formData.type = calendar.type || "";
    formData.academicYear = calendar.academicYear?.toString() || "";
    formData.startDate = formatDateForInput(calendar.startDate);
    formData.endDate = formatDateForInput(calendar.endDate);
    formData.status = calendar.status || "active";

    // Set the appropriate ID based on the calendar type
    if (calendar.type === "school" && calendar.school) {
      formData.schoolId = calendar.school.id.toString();
      // Fetch schools if not already loaded
      if (schools.value.length === 0) {
        await fetchSchools();
      }
    } else if (calendar.type === "district" && calendar.district) {
      formData.districtId = calendar.district.id.toString();
      // Fetch districts if not already loaded
      if (districts.value.length === 0) {
        await fetchDistricts();
      }
    } else if (calendar.type === "student" && calendar.student) {
      formData.studentId = calendar.student.id.toString();
      // Fetch students if not already loaded
      if (students.value.length === 0) {
        await fetchStudents();
      }
    }
  } catch (err: unknown) {
    error.value = getErrorMessage(err, "Failed to fetch calendar");
    console.error("Error fetching calendar:", err);
  } finally {
    loading.value = false;
  }
};

// Functions
const submitForm = async () => {
  // Validate dates
  if (new Date(formData.endDate) < new Date(formData.startDate)) {
    error.value = "End date cannot be before start date";
    return;
  }

  // Validate that the appropriate entity is selected based on type
  if (formData.type === "school" && !formData.schoolId) {
    error.value = "Please select a school";
    return;
  } else if (formData.type === "district" && !formData.districtId) {
    error.value = "Please select a district";
    return;
  } else if (formData.type === "student" && !formData.studentId) {
    error.value = "Please select a student";
    return;
  }

  isSubmitting.value = true;
  error.value = "";

  try {
    await axios.put(`${API_URL}/calendar/${calendarId}`, formData, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    });

    // Check if we should return to a specific page
    const returnTo = route.query.returnTo as string;
    if (returnTo) {
      router.push(returnTo);
    } else {
      // Default: redirect to calendar list
      router.push("/calendar");
    }
  } catch (err: unknown) {
    error.value = getErrorMessage(err, "Failed to update calendar");
    console.error("Error updating calendar:", err);
    isSubmitting.value = false;
  }
};

const goBack = () => {
  // Check if we should return to a specific page
  const returnTo = route.query.returnTo as string;
  if (returnTo) {
    router.push(returnTo);
  } else {
    // Default: go back to calendar list
    router.push("/calendar");
  }
};

// Lifecycle hooks
onMounted(() => {
  fetchCalendar();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    (error.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(error.value), 1))
      : _createCommentVNode("", true),
    (loading.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, _hoisted_6))
      : (_openBlock(), _createElementBlock("form", {
          key: 2,
          onSubmit: _withModifiers(submitForm, ["prevent"]),
          class: "calendar-form"
        }, [
          _createElementVNode("div", _hoisted_7, [
            _hoisted_8,
            _withDirectives(_createElementVNode("input", {
              type: "text",
              id: "name",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formData.name) = $event)),
              required: "",
              placeholder: "Enter calendar name"
            }, null, 512), [
              [_vModelText, formData.name]
            ])
          ]),
          _createElementVNode("div", _hoisted_9, [
            _hoisted_10,
            _withDirectives(_createElementVNode("textarea", {
              id: "description",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formData.description) = $event)),
              placeholder: "Enter calendar description",
              rows: "3"
            }, null, 512), [
              [_vModelText, formData.description]
            ])
          ]),
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("div", _hoisted_12, [
              _hoisted_13,
              _withDirectives(_createElementVNode("select", {
                id: "type",
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((formData.type) = $event)),
                required: "",
                onChange: handleTypeChange
              }, _hoisted_18, 544), [
                [_vModelSelect, formData.type]
              ])
            ]),
            _createElementVNode("div", _hoisted_19, [
              _hoisted_20,
              _withDirectives(_createElementVNode("select", {
                id: "academicYear",
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((formData.academicYear) = $event))
              }, [
                _hoisted_21,
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(academicYears), (year) => {
                  return (_openBlock(), _createElementBlock("option", {
                    key: year,
                    value: year
                  }, _toDisplayString(year), 9, _hoisted_22))
                }), 128))
              ], 512), [
                [_vModelSelect, formData.academicYear]
              ])
            ])
          ]),
          (formData.type === 'school')
            ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                _hoisted_24,
                _createVNode(SearchableDropdown, {
                  modelValue: formData.schoolId,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((formData.schoolId) = $event)),
                  options: schoolOptions.value,
                  placeholder: "Search and select a school"
                }, null, 8, ["modelValue", "options"])
              ]))
            : _createCommentVNode("", true),
          (formData.type === 'district')
            ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                _hoisted_26,
                _createVNode(SearchableDropdown, {
                  modelValue: formData.districtId,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((formData.districtId) = $event)),
                  options: districtOptions.value,
                  placeholder: "Search and select a district"
                }, null, 8, ["modelValue", "options"])
              ]))
            : _createCommentVNode("", true),
          (formData.type === 'student')
            ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                _hoisted_28,
                _createVNode(SearchableDropdown, {
                  modelValue: formData.studentId,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((formData.studentId) = $event)),
                  options: studentOptions.value,
                  placeholder: "Search and select a student"
                }, null, 8, ["modelValue", "options"])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_29, [
            _createElementVNode("div", _hoisted_30, [
              _hoisted_31,
              _withDirectives(_createElementVNode("input", {
                type: "date",
                id: "startDate",
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((formData.startDate) = $event)),
                required: ""
              }, null, 512), [
                [_vModelText, formData.startDate]
              ])
            ]),
            _createElementVNode("div", _hoisted_32, [
              _hoisted_33,
              _withDirectives(_createElementVNode("input", {
                type: "date",
                id: "endDate",
                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((formData.endDate) = $event)),
                required: ""
              }, null, 512), [
                [_vModelText, formData.endDate]
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_34, [
            _hoisted_35,
            _createElementVNode("div", _hoisted_36, [
              _hoisted_37,
              _withDirectives(_createElementVNode("select", {
                id: "status",
                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((formData.status) = $event))
              }, _hoisted_41, 512), [
                [_vModelSelect, formData.status]
              ]),
              _hoisted_42
            ])
          ]),
          _createElementVNode("div", _hoisted_43, [
            _createElementVNode("button", {
              type: "button",
              class: "btn-cancel",
              onClick: goBack
            }, "Cancel"),
            _createElementVNode("button", {
              type: "submit",
              class: "btn-submit",
              disabled: isSubmitting.value
            }, [
              (isSubmitting.value)
                ? (_openBlock(), _createElementBlock("span", _hoisted_45, "Saving..."))
                : (_openBlock(), _createElementBlock("span", _hoisted_46, "Update Calendar"))
            ], 8, _hoisted_44)
          ])
        ], 32))
  ]))
}
}

})